import Forbidden from "../../../AlertPages/Forbidden";
import LogoutButton from "./LogoutButton";
import ForbiddenNotification from "./ForbiddenNotification";

const ForbiddenPage = () => {
  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        position: "relative",
      }}
    >
      {<ForbiddenNotification />}
      <div
        style={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Forbidden
          message={"Awaiting authorization for IDX dashboard access."}
        />
      </div>
      <div
        style={{
          position: "absolute",
          bottom: "20px",
          left: "20px",
        }}
      >
        <LogoutButton />
      </div>
    </div>
  );
};

export default ForbiddenPage;
